import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-rapoarte-facturi-emise-search',
  templateUrl: './rapoarte-facturi-emise-search.component.html',
  styleUrls: ['./rapoarte-facturi-emise-search.component.scss']
})
export class RapoarteFacturiEmiseSearchComponent implements OnInit, OnDestroy {
  @Output() searchResult = new EventEmitter();

  rapoarteFacturiEmiseSearchForm;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {}

  ngOnInit(): void {
    this.rapoarteFacturiEmiseSearchForm = new UntypedFormGroup({
      data_start: new UntypedFormControl(null, Validators.required),
      data_end: new UntypedFormControl(null, Validators.required),
      tip: new UntypedFormControl(null),
    });
  }

  onSubmitted() {
    if (!this.rapoarteFacturiEmiseSearchForm.valid) {
      return;
    }
    this.searchResult.emit(this.rapoarteFacturiEmiseSearchForm.value);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  resetSearch() {
    this.rapoarteFacturiEmiseSearchForm.reset();
    this.onSubmitted();
  }

  onStartDateChanged(event) {
    if (this.rapoarteFacturiEmiseSearchForm) {
      this.rapoarteFacturiEmiseSearchForm.controls.data_start.setValue(event);
    }
  }

  onEndDateChanged(event) {
    if (this.rapoarteFacturiEmiseSearchForm) {
      this.rapoarteFacturiEmiseSearchForm.controls.data_end.setValue(event);
    }
  }
}
